import {SimplePresentation} from "./SimplePresentationRunner";
import {Possessed} from "../../Possessed";
import {PossessedGameMode} from "../../server/PossessedGameMode";
import {PossessedBackgroundElements} from "../../view/PossessedBackgroundElements";
import {gsap} from "gsap";
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {PossessedScatterSymbol} from "../../reels/PossessedScatterSymbol";

export class FreespinsIntroPresentation extends SimplePresentation {

    constructor() {
        super("FreespinsOutroPresentation");
    }

    shouldRun(): boolean{
        return Possessed.model.triggeredFreespins();
    }

    buildTimeline() {
        //Freespin intro
        const tl = this.tl;
        tl.eventCallback("onComplete", () => {this.controller.setSkipCallback()});
        //tl.add(Possessed.xBetView.hide(0));
        tl.add(<any>Possessed.keypadPlugin.hide(0), "<");
        const scatterSymbols = <PossessedScatterSymbol[]>Possessed.reelView.getAllVisibleSymbols().filter(s => s.name == "S");
        scatterSymbols.forEach((scatter, index) => {
            tl.add(scatter.playFsTrigger(), index == 0 ? ">" : "<");
            if(index == 0) {
                tl.add(() => {
                    Possessed.soundPlayer.playSound("scatterComplete");
                }, "<")
            }
        })
        tl.add(()=>{}, ">0.4");

        tl.add(()=> {}, ">0.5");
        tl.add(() => {
            Possessed.soundPlayer.fadeOutMusic(100);
            Possessed.soundPlayer.playSound("fsIntroStart", 1);
            Possessed.soundPlayer.playLoopingSound("fsIntroLoop", 1, 0, 0, 100);
        })
        tl.add(gsap.to(Possessed.reelView, {alpha: 0, duration: 0.2}))
        tl.add(Possessed.backgroundElements.playReverseAnimation());
        tl.add(Possessed.transitionScreen.showFreespinsIntro(), "<");
        tl.add(()=> {Possessed.transitionScreen.enableButton(() => this.onButtonClick())});
    }

    private onButtonClick() {
        const tl = gsap.timeline()
            .add(() => {
                Possessed.keypadPlugin.setZeroBetSpinCounter(Possessed.model.data.freespinsLeft);
                Possessed.keypadPlugin.show(0.1);

                Possessed.soundPlayer.stopSound("fsIntroLoop", 100);
                Possessed.soundPlayer.switchMusic(PossessedGameMode.FREESPIN);
                Possessed.soundPlayer.playSound("fsStart");
            })
            .add(() => {Possessed.backgroundElements.setMode(PossessedGameMode.FREESPIN)})
            .add(() => {Possessed.reelView.reelCross.updateCross(Possessed.model.data.nextMode)}, "<")
            .add(() => {Possessed.foregroundElements.setFreespinsLogo()}, "<")
            tl.add(Possessed.transitionScreen.hideIntroOutro(0.5), "<")
            .add(gsap.to(Possessed.reelView, {alpha: 1, duration: 0.2}), "<")
            if(Possessed.crucifixReel.visible == false) {
                tl.add(Possessed.crucifixReel.fadeIn(Possessed.model.data.xCrucifixReel.length));
                tl.add(Possessed.reelView.reelCross.updateHotZones(Possessed.model.data.nextHotZoneSize));
            }
            tl.add(()=> {this.controller.finish()});
    }
}
